import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ThemeTypings,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

type ConfirmModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  colorScheme?: ThemeTypings["colorSchemes"];
};

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  colorScheme,
}: ConfirmModalProps) => {
  const { t } = useTranslation();

  const confirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent maxW="500px">
        {/* Modal title */}
        <ModalHeader>{title ?? t("modal_confirm.title")}</ModalHeader>

        <Divider />

        {/* Modal Body */}
        <ModalBody>
          <ReactMarkdown>{message ?? t("modal_confirm.message")}</ReactMarkdown>
        </ModalBody>

        <Divider />

        {/* Modal Footer with buttons */}
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            {t("modal_confirm.cancel")}
          </Button>
          <Button colorScheme={colorScheme ?? "blue"} ml={3} onClick={() => confirm()}>
            {confirmText ?? t("modal_confirm.confirm")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmModal;
